import { render, staticRenderFns } from "./VStatic.vue?vue&type=template&id=4af76d20&scoped=true"
import script from "./VStatic.vue?vue&type=script&lang=js"
export * from "./VStatic.vue?vue&type=script&lang=js"
import style0 from "./VStatic.vue?vue&type=style&index=0&id=4af76d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af76d20",
  null
  
)

export default component.exports